<prlw-basis-details-mobile-ui
  [item]="item$ | async"
  (eventClickAboutBasis)="handleClickAboutBasis()"
  (eventClose)="eventClose.emit()"
>
  <prlw-mobile-details-card-ui
    body
    [briefDescription]="briefDescription$ | async"
    [greyTopItems]="greyTopItems$ | async"
    [whiteTopItems]="whiteTopItems$ | async"
    [whiteBottomItems]="whiteBottomItems$ | async"
    [priceOption]="priceOption$ | async"
    [showTitleAndInfoIcon]="false"
    [showButtonDetails]="false"
    (eventClickPriceOptions)="handleClickPriceOptions()"
    (eventClickInfoIcon)="handleClickAboutBasis()"
  >
  </prlw-mobile-details-card-ui>
</prlw-basis-details-mobile-ui>
